import React from 'react';
import { parseTypeSpecificParameters, getParameterIcon, capitalizeFirstLetter } from '@/components/shared/research-utils';

interface TypeSpecificParametersSectionProps {
  parameters: Record<string, any>;
}

export const TypeSpecificParametersSection: React.FC<TypeSpecificParametersSectionProps> = ({ 
  parameters 
}) => {
  const typeSpecificParams = parseTypeSpecificParameters(parameters.type_specific_filters || {});
  const hasTypeSpecificParams = Object.keys(typeSpecificParams).length > 0;

  if (!hasTypeSpecificParams) return null;

  return (
    <div className="space-y-2">
      {Object.entries(typeSpecificParams).map(([researchType, params]) => (
        <div key={researchType} className="space-y-2">
          {params.map((param) => (
            <div key={`${param.name}-${param.value}`} className="flex items-center gap-3 p-3 md:p-3 bg-background/50 dark:bg-background/80 rounded-2xl border">
              {getParameterIcon('type_specific', parameters)}
              <div className="flex-1">
                <div className="font-medium text-sm text-foreground">{param.name}</div>
                <div className="text-sm text-muted-foreground">{capitalizeFirstLetter(param.value)}</div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}; 